exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NavLink-module__NavLink___78bfy {\n  text-decoration: none;\n  font-size: 0.88rem;\n  padding: 0.5rem;\n  line-height: 1.25rem;\n  color: #fff;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.NavLink-module__NavLink___78bfy:hover, .NavLink-module__NavLink___78bfy:focus, .NavLink-module__NavLink___78bfy:active {\n  color: #dadada;\n}\n\n", ""]);

// exports
exports.locals = {
	"NavLink": "NavLink-module__NavLink___78bfy"
};